/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function BusCancellationPolicy({ cancellationPolicyString }) {
  const [cancellationRules, setCancellationRules] = useState([]);

  useEffect(() => {
    // calculate cancellation rules
    let cancellations =
      cancellationPolicyString !== '-'
        ? cancellationPolicyString.split(';')
        : [];
    cancellations = cancellations.filter((d) => d !== '');
    const rules = cancellations.map((c) => {
      const time = c.split('##');
      return {
        time: time[0],
        rule: time[1].includes('%') ? time[1] : `${time[1]}%`,
      };
    });
    setCancellationRules(rules);
  }, []);

  return (
    <section className="fw-500">
      {cancellationRules.length > 0 ? (
        <table className="table-bordered">
          <thead>
            <tr>
              <th>Cancellation Time</th>
              <th> Charges</th>
            </tr>
          </thead>
          <tbody>
            {cancellationRules.map((d, index) => (
              <tr key={index}>
                <td>{d.time}</td>
                <td className="text-center">{d.rule}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        'N/A'
      )}
    </section>
  );
}

BusCancellationPolicy.propTypes = {
  cancellationPolicyString: PropTypes.string.isRequired,
};

export default BusCancellationPolicy;
